import { styled } from '@volkswagen-onehub/components-core';
import { COLOR_TOKEN } from 'src/components/color-token';
import { css } from 'styled-components';

interface styledWrapperProps {
	notALayer?: boolean;
	isFiltrosSuggest: boolean;
	isLocating?: boolean;
	inputFocus?: boolean;
	formTheme?: string;
	isModeloSuggest?: boolean;
	isFullScreen?: boolean;
	goUp?: boolean;
	autoWidth?: boolean;
}

export const MagnifierLabel = styled.div<styledWrapperProps>`
	color: ${props =>
		props.isFiltrosSuggest || props.formTheme == 'inverted'
			? COLOR_TOKEN.inverted.content.primary
			: COLOR_TOKEN.main.content.primary};
	padding-right: 8px;
	display: flex;
	align-items: center;

	& svg {
		fill: ${props =>
			props.isLocating && props.isFiltrosSuggest
				? COLOR_TOKEN[props.formTheme].content.primary
				: COLOR_TOKEN[props.formTheme].content.secondary};
	}
`;
export const SuggestCloseButton = styled.button<styledWrapperProps>`
	cursor: pointer;
	border: none;
	outline: none;
	background-color: transparent;
	padding-left: 8px;
	display: flex;
	align-items: center;

	& svg {
		fill: ${props =>
			props.isLocating && props.isFiltrosSuggest
				? COLOR_TOKEN[props.formTheme].content.primary
				: COLOR_TOKEN[props.formTheme].content.secondary};
	}
`;

export const StyledWrapper = styled.div<styledWrapperProps>`
	display: flex;
	justify-content: flex-start;
	margin-top: ${props => (props.isFiltrosSuggest ? '24px' : null)};
	padding: 9px 16px;
	border-radius: 8px;
	box-shadow: ${props =>
		props.inputFocus && !props.isLocating
			? `0 0 0 3px ${COLOR_TOKEN[props.formTheme].focus.main}`
			: `0 0 0 1px ${COLOR_TOKEN[props.formTheme].border.default}`};

	& svg {
		fill: ${props =>
			props.inputFocus && !props.isLocating
				? `0 0 0 3px ${COLOR_TOKEN[props.formTheme].focus.main}`
				: `0 0 0 1px ${COLOR_TOKEN[props.formTheme].border.default}`};
	}

	& .react-autosuggest__container {
		width: 100%;
	}

	& .react-autosuggest__input {
		width: 100%;
		padding: 8px 0;
		border: none;
		background-color: transparent;
		color: ${props =>
			props.isLocating && props.isFiltrosSuggest
				? COLOR_TOKEN[props.formTheme].content.primary
				: COLOR_TOKEN[props.formTheme].content.secondary};
		/* Añadir puntos suspensivos para el placeholder en mobile */
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		/* WebKit, Edge */
		::-webkit-input-placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
		}
		/* Firefox 4-18 */
		:-moz-placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
			opacity: 1;
		}
		/* Firefox 19+ */
		::-moz-placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
			opacity: 1;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
		/* IE 10-11 */
		:-ms-input-placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
		}
		/* Edge */
		::-ms-input-placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
		}
		/* MODERN BROWSER */
		::placeholder {
			color: ${props =>
				props.isLocating && props.isFiltrosSuggest
					? COLOR_TOKEN[props.formTheme].content.primary
					: COLOR_TOKEN[props.formTheme].content.secondary};
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}

	& .react-autosuggest__input--focused {
		outline: none;
	}

	& .react-autosuggest__input--open {
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}

	& .react-autosuggest__suggestions-container {
		display: none;
		width: 100%;
	}

	& .react-autosuggest__suggestions-container--open {
		display: block;
		position: absolute;
		height: max-content;
		border: 1px solid ${COLOR_TOKEN.main.border.default};
		border-radius: 4px;
		background-color: ${COLOR_TOKEN.main.background.tertiary};
		font-family: Helvetica, sans-serif;
		font-weight: 300;
		font-size: 16px;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		z-index: 1060;
		overflow: hidden;
		border: none;
		box-shadow: 0px 12px 24px 0px ${COLOR_TOKEN.main.overlay.default};

		left: 0;
		top: ${props => (props.goUp ? '0' : '53px')};
		transform: ${props => (props.goUp ? 'translateY(-100%)' : null)};

		${props =>
			props.isFiltrosSuggest
				? css`
						width: calc(100% + 68x);
						@media screen and (min-width: 960px) {
							width: 400px;
						}
				  `
				: props.isModeloSuggest
				? css<styledWrapperProps>`
						width: var(--size-grid020);
						@media all and (min-width: 560px) {
							width: ${(props: styledWrapperProps) =>
								props.notALayer
									? 'var(--size-grid013)'
									: '303px'};
						}
						@media all and (min-width: 960px) {
							width: ${(props: styledWrapperProps) =>
								props.notALayer
									? 'var(--size-grid008)'
									: '320px'};
						}
						@media all and (min-width: 1280px) {
							width: ${(props: styledWrapperProps) =>
								props.notALayer
									? 'var(--size-grid006)'
									: '320px'};
						}
						@media all and (min-width: 1920px) {
							width: ${(props: styledWrapperProps) =>
								props.notALayer
									? 'var(--size-grid005)'
									: '320px'};
						}
						@media all and (min-width: 2560px) {
							width: ${(props: styledWrapperProps) =>
								props.notALayer
									? 'var(--size-grid004)'
									: '320px'};
						}
				  `
				: props.isFullScreen
				? css<styledWrapperProps>`
						width: var(--size-grid020);
						@media all and (min-width: 960px) {
							width: ${(props: styledWrapperProps) =>
								props.autoWidth
									? '100%'
									: 'var(--size-grid013)'};
						}
						@media all and (min-width: 1280px) {
							width: ${(props: styledWrapperProps) =>
								props.autoWidth
									? '100%'
									: 'var(--size-grid014)'};
						}
						@media all and (min-width: 1920px) {
							width: ${(props: styledWrapperProps) =>
								props.autoWidth
									? '100%'
									: 'var(--size-grid012)'};
						}
						@media all and (min-width: 2560px) {
							width: ${(props: styledWrapperProps) =>
								props.autoWidth
									? '100%'
									: 'var(--size-grid010)'};
						}
				  `
				: css`
						width: calc(100% + 68x);
						@media screen and (min-width: 960px) {
							width: 720px;
						}
				  `}
	}

	& .react-autosuggest__suggestions-list {
		margin: 0;
		padding: 0;
		list-style-type: none;
		overflow: hidden scroll;
		height: max-content;
		max-height: 170px;
		@media all and (min-height: 500px) {
			max-height: 230px;
		}
		@media all and (min-height: 800px) {
			max-height: 300px;
		}
		@media all and (min-height: 800px) {
			max-height: 350px;
		}
	}

	& .react-autosuggest__suggestion {
		cursor: pointer;
		padding: 10px 20px;
		left: 0;
		:hover {
			* {
				color: ${COLOR_TOKEN.main.accent.nbab.default};
			}
			svg {
				fill: ${COLOR_TOKEN.main.accent.nbab.default};
			}
		}
	}
`;

export const SuggestionWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	text-align: left;
	color: ${COLOR_TOKEN.main.content.primary};
`;
